import * as React from "react";
import clsx from "clsx";
import { Tag } from "../tag/tag.mjs";
const TagGroup = (props) => {
  const { align = "vertical", tags, size, className, ...rest } = props;
  return /* @__PURE__ */ React.createElement("div", { className: clsx("tag-group", "tag-group--align-".concat(align), className), ...rest }, tags.map((tag, index) => /* @__PURE__ */ React.createElement(Tag, { ...tag, key: index, size, className: clsx("tag-group__tag", tag.className) })));
};
export {
  TagGroup
};
